import validator from 'validator';

const SUPPORTED_NAME_LOCALES = ['ar', 'en-US', 'pl-PL'] as const;

export const NAME_VALIDATION_MESSAGE = 'Only letters, digits, spaces and hyphens are allowed.';

export function isSupportedName(value: string): boolean {
    const valueWithoutHyphensAndWhiteSpace = validator.blacklist(`${value}`, '- ');
    if (!valueWithoutHyphensAndWhiteSpace) {
        return true;
    }
    return SUPPORTED_NAME_LOCALES.some((locale) => validator.isAlphanumeric(valueWithoutHyphensAndWhiteSpace, locale));
}
